@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (ListBookingQuestion && AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div class="text-900 font-medium text-xl mb-3"><h3>Booking Questions
    </h3></div>
    <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
      <span class="pi pi-info-circle" style="margin-right:2px;"></span>
      <div class="list-toolbar" style="text-align: right; margin-bottom: 20px;">
        <p-togglebutton class="p-component" [(ngModel)]="isDisabled" onLabel="Show Disabled" offLabel="Hide Disabled" offIcon="pi pi-times" onIcon="pi pi-check" [style]="{'margin-right': '10px', 'color' : 'white', 'background-color': '#EF4444', 'height': '50px'}" (click)="toggleDisabled()">
        </p-togglebutton>
        <span class="p-input-icon-left ml-auto" style="margin-right:20px; ">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="classTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" placeholder="Question Name" />
        </span>
        <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-success p-button p-component" [routerLink]="['/bookingquestionedit/0']" i18>
          <span class="pi pi-plus" style="margin-right:8px;"></span>
          <span i18>Add</span>
        </button>
        &nbsp;
        <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableMulti()">
          <span class="pi pi-trash" style="margin-right:8px;"></span>
          <span i18>Disable</span>
        </button>
      </div>
      <div class="surface-card p-4 shadow-2 border-round">
        <p-table  #classTable
          [value]="ListBookingQuestion.data" sortField="name" [paginator]="true" [rows]="10"
          [showCurrentPageReport]="true" responsiveLayout="scroll"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          [rowsPerPageOptions]="[10,25,50]"
          [globalFilterFields]="['questiontext']"
          [(selection)]="selectedItems"
          responsiveLayout="scroll"
          datakey="classID"
          [selectionPageOnly]="true">
          <ng-template #header>
            <tr>
              <th>
                <p-tableheadercheckbox></p-tableheadercheckbox>
              </th>
              <th pSortableColumn="questiontext" width="65%">Question
                <p-sorticon field="questiontext"></p-sorticon>
              </th>
              <th pSortableColumn="questiontype" width="25%">Type
                <p-sorticon field="questiontype"></p-sorticon>
              </th>
              <th width="5%"></th>
              <th width="5%"></th>
              <th width="5%"></th>
            </tr>
          </ng-template>
          <ng-template #body let-data>
            <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
              <td>
                <p-tablecheckbox [value]="data"></p-tablecheckbox>
              </td>
              <td>{{data.questiontext}}</td>
              <td>{{questionTypeName(data.questiontype)}}</td>
              <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="background-color: yellow o !important;" (click)="editData(data.bookingquestionid);" i18>
                <span class="pi pi-pencil" style="margin-right:8px;"></span>
                <span i18n>Edit</span>
              </button></td>
              <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-warn p-button p-component" style="margin-left:-20px;" (click)="copydata(data.bookingquestionid)">
                <span class="pi pi-copy" style="margin-right:8px;"></span>
                <span i18n>Copy</span>
              </button></td>
              <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" style="margin-left:-20px;"  (click)="disableData(data.bookingquestionid)" i18>
                <span class="pi pi-trash" style="margin-right:8px;"></span>
                <span i18n>Disable</span>
              </button></td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  }
